<script lang="ts">
import { inject, ref } from 'vue'
import { navItems } from '@/config'
import NavItem from './NavItem.vue'
import BusinessSelector from './BusinessSelector.vue'
import store from "@/store";
import { settings } from "@/settings";
export default {
  components: { NavItem, BusinessSelector },

  setup() {
    // Etat replie fourni par App.vue : le menu et ses items s'y adaptent.
    const sidebarMini = inject('sidebarMini', ref(false))
    const appVersion = `${settings.appVersion}`;
    return { navItems, sidebarMini, appVersion }

  },
  computed: {
    isUserLogged() {
      return !!(store.state.authModule?.user && store.state.authModule.user.loggedIn);
    },
    isChangePassWord() {
      return store.state.authModule?.changePassworIn;
    },
  }
}
</script>

<template>
  <div class="tw-side-nav-inner fit">
    <q-scroll-area class="tw-side-nav-scroll">
      <q-list class="tw-side-nav-list">
        <template v-for="(menuItem, index) in navItems" :key="index">
          <NavItem :item="menuItem" />
        </template>
      </q-list>
    </q-scroll-area>

    <!-- Affaire active : remontee du header vers le pied du menu -->
    <div class="tw-side-nav-footer">
      <BusinessSelector :mini="sidebarMini" />
    </div>
    <div class="tw-app-version-wrapper tw-app-version-side-bar w-100" v-if="isUserLogged && isChangePassWord">
      <span class="d-block font-size-11 text-primary text-right w-100">{{
        appVersion
        }}</span>
    </div>
  </div>
</template>
